import { useCallback, useEffect, useMemo, useState } from 'react';
import { useAddAlert, useFSMapCategory, useFSMapFuel, useFSMapMethod, useFSMapSubCat, useFuelList, useCategoryList, useMethodList, useSubCatList} from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import { getCategoryByType, getCodes } from 'src/apis/getFuelSampleCalls';
import { ValidCharacters, buildPath, errorResponse, validateCharacters } from 'src/store/common';
import { alertMessages } from 'src/constants';
import { Autocomplete, Box, Button, Modal, TextField ,  Typography,
    IconButton,
    Divider,} from '@mui/material';
import '../../../field-sample/FuelTypes/FuelTypesBrowse.scss'
import { useHistory, useLocation } from 'react-router';
import { ROUTE_PATHS } from 'src/routes';
import FuelTable from './FuelTable';
import CloseIcon from "@mui/icons-material/Close";

const FieldSampleSelect = ()=>{
    const [state, dispatch] = useStoreContext();
    const allCodeObj =  useMemo(()=>({code_key: "None",code_table_id: -1, code_value:'None', type:'None'}),[]);
    const history = useHistory();
    const location = useLocation(); 

    const addAlert = useAddAlert(dispatch);

    const setFSMapCatgory = useFSMapCategory(dispatch);
    const setFSMapFuel = useFSMapFuel(dispatch);
    const setFSMapSubCat = useFSMapSubCat(dispatch);
    const setFSMapMethod = useFSMapMethod(dispatch);

    const setFuelList = useFuelList(dispatch);
    const setCatList = useCategoryList(dispatch);
    const setSubCatList = useSubCatList(dispatch);
    const setMethodList = useMethodList(dispatch);

    const [categories, setCategories] = useState<any[]>([]);
    const [inputCategory, setInputCategory] = useState('');

    
    const [inputType, setInputType] = useState('');
    const [fuels, setFuels] = useState<any[]>([]);

    const [methods, setMethods] = useState<any[]>([allCodeObj]);
    const [inputMethod, setInputMethod] = useState('');

    const [subCategories, setSubCategories] = useState<any[]>([allCodeObj]);
    const [inputSubCategory, setInputSubCategory] = useState('');
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    /*below will take into account the path */

    useEffect(() => {
        if (location.search) {
            const stringArray = decodeURIComponent(location.search).split("/");
            if (stringArray.length>=9) {
                const stringArray = decodeURIComponent(location.search).split("/");
                const category = stringArray[1];
                const fuelType = stringArray[2];
                const method = stringArray[7];
                const subCategory = stringArray[8]
                if (fuelType !== state.fsMapFuel?.fuel_type) {
                    const findFuel = fuels.find(f=>f.fuel_type===fuelType)
                    if(findFuel){
                        setFSMapFuel(findFuel)
                    }
                }
                if (state.fsMapCategory !== category) {
                    const findCategory = categories.find(c=>c===category);
                    if(findCategory){
                        setFSMapCatgory(findCategory)
                    }
                }
                if (state.fsMapMethod.code_key !== method) {
                    const findMethod = methods.find(m=>m.code_key===method);
                    if(findMethod){
                        setFSMapMethod(findMethod)
                    }
                }
                if (state.fsMapSubCat.code_key !== subCategory) {
                    const findSubCat = subCategories.find(sc=>sc.code_key===subCategory);
                    if(findSubCat){
                        setFSMapSubCat(findSubCat)
                    }

                }
            }
            else {
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.fsMapCategory,
                    element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.fsMapMethod.code_key,
                    windOrSub: state.fsMapSubCat.code_key
                }
                buildPath(paramsForBuildPath, history);

            }
        }
        if (!location.search) {
            if (sessionStorage.getItem('path')) {
                const path = sessionStorage.getItem('path');
                if (path !== null) {
                    history.push({ pathname: `${ROUTE_PATHS.home}`, search: path });
                }
            }
            else {
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.fsMapCategory,
                    element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.fsMapMethod.code_key,
                    windOrSub: state.fsMapSubCat.code_key
                }
                buildPath(paramsForBuildPath, history);
            }
        }

    }, [ state.selectedBaseMap.id, location.search, state.currentZoom, history, state.elevationFilterValues, state.mapDataType,
        state.fsMapCategory, state.fsMapFuel, state.fsMapMethod.code_key, state.fsMapSubCat.code_key,
        categories, fuels, methods, subCategories, setFSMapCatgory, setFSMapFuel, setFSMapSubCat, setFSMapMethod

    ]);
    /* this will get the fuel type and category so they are filtered on the dropdown*/
    const toGetCategory = useCallback((type?: string, cat?: string, getAll?: boolean)=>{
        (async () => {
          try {
            const responseArray: any = await getCategoryByType(null, addAlert, type, cat, getAll);
            if (responseArray) {
              let uniqueCategories: any[] = [...new Set(responseArray.map((r: any) => r.category))];
              let uniqueTypes: any[] = [...new Set(responseArray.map((r: any) => r))];
              if(getAll){
                setFuelList(uniqueTypes);
                setCatList(uniqueCategories.sort((a:string,b:string)=>a.localeCompare(b)));
                setFuels(uniqueTypes.sort((a:any,b:any)=>a.fuel_type.localeCompare(b.fuel_type)));
                setCategories(uniqueCategories);
              }
              else if (cat) {
                setFuels(uniqueTypes.sort((a:any,b:any)=>a.fuel_type.localeCompare(b.fuel_type)));
              }
      
            }
            else {
              setCategories([]);
              setFuels([])
            }
          }
          catch (error) {
            errorResponse(error, addAlert, alertMessages.fieldSampleHomeData);
          }
      
        })();
      },[addAlert, setFuelList, setCatList]);

    /* code table calls*/
    useEffect(()=>{
        let codeResponse:any = [];
        if(codeResponse.length<2){
          (async()=>{
            try{
              const requestVars ={
                returnAll: true,
                type: null
              }
              codeResponse = await getCodes(requestVars);
              toGetCategory('All', 'All', true);

              const subCats = codeResponse.subCats;
              subCats.unshift(allCodeObj)
              const methodsFromCall = codeResponse.methods;
              methodsFromCall.unshift(allCodeObj);

              setSubCatList(subCats);
              setMethodList(methodsFromCall)
              setSubCategories(subCats);
              setMethods(methodsFromCall);
            }
            catch(error){
              errorResponse(error, addAlert, alertMessages.siteSampleData);    
            } 
          })();
        }
    },[ addAlert, allCodeObj, toGetCategory, setMethodList, setSubCatList]);

    const handleCategorySelect =(event:any, newValue: any)=>{
        setFSMapCatgory(newValue);
        setFSMapFuel(null)
        toGetCategory('All', newValue);
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: newValue,
            element: null,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: state.fsMapMethod.code_key,
            windOrSub: state.fsMapSubCat.code_key
        }
        buildPath(paramsForBuildPath, history);
    };

    const handleFuelSelect =(event: any, value: any)=>{
        setFSMapFuel(value)
        setFSMapCatgory(value.category)
        toGetCategory(value.fuel_type);
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: value.category,
            element: value.fuel_type,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: state.fsMapMethod.code_key,
            windOrSub: state.fsMapSubCat.code_key
        }
        buildPath(paramsForBuildPath, history);
    };

    const handleMethodSelect =(event: any, value: any)=>{
        setFSMapMethod(value);
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: state.fsMapCategory,
            element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: value.code_key,
            windOrSub: state.fsMapSubCat.code_key
        }
        buildPath(paramsForBuildPath, history);
    };

    const handleAll =(event: any, categoryValue: any, subCategoryValue: any, fuelTypeValue : any, methodValue: any)=>{
        const methodSelected = methodValue === null? 'None':methodValue;
        const subCatSelected = subCategoryValue === null? 'None':subCategoryValue;

        const findFuel = fuels.find(f=>f.fuel_type===fuelTypeValue)
        if(findFuel){
            setFSMapFuel(findFuel)
        }
        const findCategory = categories.find(c=>c===categoryValue);
        if(findCategory){
            setFSMapCatgory(findCategory);
        }

        const findSubCat = subCategories.find(sc=>sc.code_key===subCatSelected);
        if(findSubCat){
            setFSMapSubCat(findSubCat)
        }
        const findMethod = methods.find(m=>m.code_key===methodSelected);
        if(findMethod){
            setFSMapMethod(findMethod)
        }
        toGetCategory('All', categoryValue);

        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: categoryValue, 
            element: fuelTypeValue,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: methodSelected,
            windOrSub: subCatSelected
        }
        buildPath(paramsForBuildPath, history);
    };

    const handleSubCategorySelect =(event: any, value: any)=>{
        setFSMapSubCat(value);
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: state.fsMapCategory,
            element: state.fsMapFuel? state.fsMapFuel.fuel_type:null,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: state.fsMapMethod.code_key,
            windOrSub: value.code_key
        }
        buildPath(paramsForBuildPath, history);
    };
    return(
        <div>
            <div>
                {/* Trigger Button */}
                <div style={{ position: "relative" }}>
                    <div style={{ display: "inline-block", width: "73%" }}>
                    <label
                        className="font-sans-sm text-bold"
                        style={{ fontSize: "12px" }}
                        htmlFor="category"
                    >
                        Category
                    </label>
                    </div>
                    <Button
                    style={{
                        fontSize: "12px",
                        textDecoration: "underline",
                        textTransform: "none",
                        padding: "0",
                        color: "#125393",
                    }}
                    variant="text"
                    onClick={handleOpen}
                    >
                    Search
                    </Button>
                </div>

                 {/* Modal */}
                 <Modal open={open} onClose={handleClose}>
                        <Box
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                width: "90vw", 
                                height: "90vh", 
                                bgcolor: "background.paper",
                                boxShadow: 24,
                                p: 2,
                                borderRadius: "8px",
                                display: "flex",
                                flexDirection: "column",
                                overflow: "hidden",
                              }}
                        >
                            {/* Header Section */}
                            <Box display="flex" alignItems="center" justifyContent="space-between" pb={2} sx={{ flexShrink: 0 }}>
                            <Typography variant="h6" component="h2" fontWeight="bold">
                                Browse Fuel Types
                            </Typography>
                            <IconButton onClick={handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            </Box>
                            <Divider />
                        <Box
                            sx={{
                                flexGrow: 1, 
                                overflow: "hidden", 
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            {/* FuelTable Component */}
                            <FuelTable  handleAll={handleAll} handleClose={handleClose}/>
                        </Box>                            
                        </Box>
                </Modal>
                <Autocomplete
                    className={'mapStyle'}
                    value={state.fsMapCategory}
                    aria-labelledby='category'
                    id="category"
                    onChange={(event: any, newValue: any) => {handleCategorySelect(event, newValue)}}
                    inputValue={inputCategory}
                    onInputChange={(event, newInputValue) => {
                        setInputCategory(newInputValue);
                    }}
                    options={(categories)}
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                        style={{fontSize: '11px'}}
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                        data-testid={'category'}
                        {...params}
                        label=""
                        placeholder='Select a Category'
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                        />
                )}
                
                />
            </div>
            <div>
            <label className="font-sans-sm text-bold" style={{fontSize: '12px'}} htmlFor='sampleType'>Fuel</label>

                <Autocomplete
                    className={'mapStyle'}
                    value={state.fsMapFuel}
                    aria-labelledby='sampleType'
                    id="sampleType"
                    onChange={(event: any, newValue: any) => {handleFuelSelect(event, newValue)}}
                    inputValue={inputType}
                    onInputChange={(event, newInputValue) => {
                        setInputType(newInputValue);
                    }}
                    options={(fuels)}
                    getOptionLabel={(option) => (option && option.fuel_type) || option}
                    isOptionEqualToValue={(option,value)=> option.fuel_id===value.fuel_id}
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                        data-testid={'fuel_type'}
                        {...params}
                        label=""
                        placeholder='Select a Fuel'
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                        />
                )}
                
                />
            </div>
            <div>
            <label className="font-sans-sm text-bold" style={{fontSize: '12px'}} htmlFor='method'>Method</label>
                <Autocomplete
                    className={'mapStyle'}
                    value={state.fsMapMethod}
                    aria-labelledby='method'
                    id="method"
                    onChange={(event: any, newValue: any) => {handleMethodSelect(event, newValue)}}
                    inputValue={inputMethod}
                    onInputChange={(event, newInputValue) => {
                        setInputMethod(newInputValue);
                    }}
                    options={(methods)}
                    getOptionLabel={(option) => (option &&option.code_key) || "None"}
                    isOptionEqualToValue={(option,value)=> option.code_key===value.code_key}
                    disableClearable
                    renderInput={(params) => (
                        <TextField
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                        data-testid={'method'}
                        {...params}
                        label=""
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                        />
                )}
                
                />
            </div>
            <div>
            <label className="font-sans-sm text-bold" style={{fontSize: '12px'}} htmlFor='subCategory'>Sub-Category</label>

                <Autocomplete
                    className={'mapStyle'}
                    value={state.fsMapSubCat}
                    aria-labelledby='subCategory'
                    id="subCategory"
                    onChange={(event: any, newValue: any) => {handleSubCategorySelect(event, newValue)}}
                    inputValue={inputSubCategory}
                    onInputChange={(event, newInputValue) => {
                        setInputSubCategory(newInputValue);
                    }}
                    options={(subCategories)}
                    getOptionLabel={(option) => (option &&option.code_key) || "None"}
                    isOptionEqualToValue={(option,value)=> option.code_key===value.code_key}

                    disableClearable
                    renderInput={(params) => (
                        <TextField
                        onInput={(e) => validateCharacters(e, ValidCharacters.TextField, ValidCharacters.Hyphen, ValidCharacters.Comma)}
                        data-testid={'subCategory'}
                        {...params}
                        label=""
                        InputProps={{
                            ...params.InputProps,
                            type: 'search',
                        }}
                        />
                )}
                
                />
            </div>
        </div>
    )
}
export default FieldSampleSelect;